<template>
  <div>
    <v-autocomplete
      v-model="selectedAgent"
      :items="agents"
      :loading="apiInProgress"
      :search-input.sync="searchKeywords"
      :filter="customFilter"
      item-text="fullName"
      item-value="id"
      return-object
      clearable
      hide-no-data
      v-bind="childProps"
    >
      <template slot="item" slot-scope="{ item }">
        <div style="width: 100%">
          <div>{{item.fullName}}</div>
          <div><em><small>{{item.phone || item.email}}</small></em></div>
          <hr style="width: 100%; border: 0; border-bottom: 1px solid #ccc" />
        </div>
      </template>
      <template slot="selection" slot-scope="{ item }">
        <div>
          <div>{{item.fullName}}</div>
          <div><em><small>{{item.phone || item.email}}</small></em></div>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import src from './src'
export default src
</script>
